import { GenerateQuestionsRequestDto } from '../../helper-types/dtos/ai/requests/generate-questions-request-dto';
import { SendChatMessageRequestDto } from '../../helper-types/dtos/ai/requests/send-chat-message-request-dto';
import { AssistantChatResponseDto } from '../../helper-types/dtos/ai/responses/assistant-chat-response-dto';
import { AvailableToolResponseDto } from '../../helper-types/dtos/ai/responses/available-tool-response-dto';
import { GeneratedQuestionResponseDto } from '../../helper-types/dtos/ai/responses/generated-question-response-dto';
import { ExtractExamQuestionsResponseDto } from '../../helper-types/dtos/ai/responses/extract-exam-questions-response-dto';
import { API_RELATIVE_URI } from '../../helper-types/general/consts/api-relative-uri';
import { ApiResponse } from '../../helper-types/general/custom-types/api-response';
import HTTP_CLIENT from '../common/http-client-wrapper';

export class AIService {
    private readonly _httpClient: typeof HTTP_CLIENT;

    constructor(httpClient: typeof HTTP_CLIENT) {
        this._httpClient = httpClient;
    }

    async generateQuestionsAsync(
        dto: GenerateQuestionsRequestDto
    ): Promise<ApiResponse<GeneratedQuestionResponseDto[]>> {
        return await this._httpClient.postAsJsonAsync<
            GenerateQuestionsRequestDto,
            ApiResponse<GeneratedQuestionResponseDto[]>
        >(API_RELATIVE_URI.AI_GENERATE_QUESTIONS, dto);
    }

    async extractExamQuestionsAsync(
        file: File,
        questionsBankId: number,
        notes?: string
    ): Promise<ApiResponse<ExtractExamQuestionsResponseDto>> {
        // Mirrors MediaService.uploadDocumentAsync's convention: for an action with an IFormFile
        // parameter, ASP.NET Core only special-cases the file itself — other simple-type params
        // must travel via the query string, not as extra form fields, or they bind to their
        // default (silently, no error) instead of the real value.
        const notesParam = notes ? `&notes=${encodeURIComponent(notes)}` : '';
        const formData = new FormData();
        formData.append('file', file);
        return await this._httpClient.postFormAsync<ApiResponse<ExtractExamQuestionsResponseDto>>(
            `${API_RELATIVE_URI.AI_EXTRACT_EXAM_QUESTIONS}?questionsBankId=${questionsBankId}${notesParam}`,
            formData
        );
    }

    async getAvailableToolsAsync(): Promise<ApiResponse<AvailableToolResponseDto[]>> {
        return await this._httpClient.getFromJsonAsync<ApiResponse<AvailableToolResponseDto[]>>(
            API_RELATIVE_URI.AI_TOOLS
        );
    }

    async chatAsync(
        dto: SendChatMessageRequestDto
    ): Promise<ApiResponse<AssistantChatResponseDto>> {
        return await this._httpClient.postAsJsonAsync<
            SendChatMessageRequestDto,
            ApiResponse<AssistantChatResponseDto>
        >(API_RELATIVE_URI.AI_CHAT, dto);
    }
}

export const AI_SERVICE = new AIService(HTTP_CLIENT);
